import { handleApiError, hashIdentifier, type IBusiness, showToast } from 'BreetHelpers';
import {
	clearCredentials,
	logUserIn,
	selectLastVisited,
	selectLastVisitedOwner,
	setBusiness,
	useAppDispatch,
	useAppSelector,
	usersApiSlice,
} from 'BreetRedux';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { inactivityStorage } from '@/lib';

export const useLoginSuccess = () => {
	const navigate = useNavigate();

	const dispatch = useAppDispatch();

	const lastVisited = useAppSelector(selectLastVisited);
	const lastVisitedOwner = useAppSelector(selectLastVisitedOwner);

	const onLoginSuccess = useCallback(
		async (business?: IBusiness, email?: string) => {
			dispatch(clearCredentials());
			inactivityStorage.update('lastActivity', Date.now());

			try {
				const response = await dispatch(usersApiSlice.endpoints.getUser.initiate(undefined, { forceRefetch: true })).unwrap();
				if (!response.data) {
					showToast('error', 'We couldn’t complete your sign-in. Please try again.');
					return;
				}
			} catch (error) {
				handleApiError(error);
				return;
			}

			dispatch(logUserIn());
			dispatch(setBusiness(business ?? null));

			const isSameUser = !!lastVisited && !!lastVisitedOwner && !!email && hashIdentifier(email) === lastVisitedOwner;
			navigate(isSameUser ? lastVisited : '/home')?.catch(console.error);

			showToast('success', 'Login successful. Welcome back! 🎉');
		},
		[dispatch, lastVisited, lastVisitedOwner, navigate]
	);

	return {
		onLoginSuccess,
	};
};
